(() => {
  const CONFIG = {
    canvasSize: 1000,
    layout: {
      name: {
        centerX: 500,
        centerY: 245,
        maxWidth: 460,
        maxHeight: 110,
        wrapBelowPx: 65,
        fontSizePx: {
          corsivo: 102,
          stampatello: 124
        },
        twoLineCapDivisor: {
          corsivo: 1.6,
          stampatello: 1.1
        },
        twoLineOffsetFactor: {
          corsivo: 0.55,
          stampatello: 0.4
        },
        forceWrapAfterChars: {
          corsivo: 999,
          stampatello: 12
        }
      },
      design: {
        centerX: 500,
        centerY: 670,
        maxWidth: 275,
        maxHeight: 250
      }
    },
    textColors: {
      leone:       { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      orso:        { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      elefante:    { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      giraffa:     { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      volpe:       { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      coniglio:    { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      dinosauro:   { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      cane:        { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      gatto:       { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      coccinella:  { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      balena:      { blu:"#52abe5", rosa:"#10235b", natural:"#10235b", ambra:"#fef9d0", verde:"#fef9d0" },
      tartaruga:   { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      granchio:    { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      escavatore:  { blu:"#52abe5", rosa:"#10235b", natural:"#10235b", ambra:"#52abe5", verde:"#52abe5" },
      astronauta:  { blu:"#fef9d0", rosa:"#10235b", natural:"#10235b", ambra:"#fef9d0", verde:"#fef9d0" },
      cavaliere:   { blu:"#fef9d0", rosa:"#10235b", natural:"#10235b", ambra:"#fef9d0", verde:"#fef9d0" },
      pirata:      { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      maghetto:    { blu:"#fef9d0", rosa:"#10235b", natural:"#10235b", ambra:"#fef9d0", verde:"#fef9d0" },
      principessa: { blu:"#d979ae", rosa:"#d979ae", natural:"#d979ae", ambra:"#fef9d0", verde:"#fef9d0" },
      fatina:      { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      sirenetta:   { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      ballerina:   { blu:"#d979ae", rosa:"#d979ae", natural:"#d979ae", ambra:"#fef9d0", verde:"#fef9d0" },
      "fiocco-rosa":        { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      "fiocco-marrone":     { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#fef9d0", verde:"#fef9d0" },
      "arcobaleno-rosa":    { blu:"#d979ae", rosa:"#993b0a", natural:"#993b0a", ambra:"#993b0a", verde:"#fef9d0" },
      "arcobaleno-marrone": { blu:"#fef9d0", rosa:"#483023", natural:"#483023", ambra:"#483023", verde:"#483023" },
      "arcobaleno-blu":     { blu:"#52abe5", rosa:"#10235b", natural:"#10235b", ambra:"#10235b", verde:"#10235b" }
    },
    overrides: {
      balena:               { maxWidth: 325, maxHeight: 225 },
      escavatore:           { maxWidth: 300, maxHeight: 175 },
      granchio:             { maxWidth: 290, maxHeight: 198 },
      tartaruga:            { maxWidth: 290, maxHeight: 198 },
      "fiocco-rosa":        { maxWidth: 220, maxHeight: 220 },
      "fiocco-marrone":     { maxWidth: 220, maxHeight: 220 },
      "arcobaleno-blu":     { maxWidth: 290, maxHeight: 172 },
      "arcobaleno-rosa":    { maxWidth: 290, maxHeight: 172 },
      "arcobaleno-marrone": { maxWidth: 290, maxHeight: 172 }
    }
  };

  const valueMaps = {
    backpack: {
      "Natural": "natural",
      "Rosa": "rosa",
      "Blu": "blu",
      "Ambra": "ambra",
      "Verde Salvia": "verde"
    },
    design: {
      "Leone": "leone",
      "Orso": "orso",
      "Elefante": "elefante",
      "Giraffa": "giraffa",
      "Volpe": "volpe",
      "Coniglio": "coniglio",
      "Dinosauro": "dinosauro",
      "Cane": "cane",
      "Gatto": "gatto",
      "Coccinella": "coccinella",
      "Balena": "balena",
      "Tartaruga": "tartaruga",
      "Granchio": "granchio",
      "Escavatore": "escavatore",
      "Astronauta": "astronauta",
      "Cavaliere": "cavaliere",
      "Pirata": "pirata",
      "Mago": "maghetto",
      "Principessa": "principessa",
      "Fata": "fatina",
      "Sirena": "sirenetta",
      "Ballerina": "ballerina",
      "Fiocco Rosa": "fiocco-rosa",
      "Fiocco Marrone": "fiocco-marrone",
      "Arcobaleno Marrone": "arcobaleno-marrone",
      "Arcobaleno Rosa": "arcobaleno-rosa",
      "Arcobaleno Blu": "arcobaleno-blu"
    },
    font: {
      "Corsivo": "corsivo",
      "Stampatello": "stampatello"
    }
  };

  const imageCache = new Map();
  let fontsReady = false;
  let renderToken = 0;

  function loadImage(src) {
  if (!src) return Promise.resolve(null);
  if (imageCache.has(src)) return imageCache.get(src);

  const promise = new Promise((resolve, reject) => {
    const img = new Image();
    img.decoding = 'async';

    img.onload = async () => {
      try {
        if (img.decode) {
          await img.decode();
        }
      } catch (e) {}
      resolve(img);
    };

    img.onerror = reject;
    img.src = src;
  });

  imageCache.set(src, promise);
  return promise;
}

 function loadOptionalImage(src) {
  if (!src) return Promise.resolve(null);
  if (imageCache.has(src)) return imageCache.get(src);

  const promise = new Promise((resolve) => {
    const img = new Image();
    img.decoding = 'async';

    img.onload = async () => {
      try {
        if (img.decode) {
          await img.decode();
        }
      } catch (e) {}
      resolve(img);
    };

    img.onerror = () => resolve(null);
    img.src = src;
  });

  imageCache.set(src, promise);
  return promise;
}

  function getConfigData() {
    const el = document.getElementById('hbPreviewConfig');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('Config preview non valida', error);
      return null;
    }
  }

  function getCheckedValue(name) {
    const input = document.querySelector(`input[name="${name}"]:checked`);
    return input ? input.value : '';
  }

  function getInputValue(name) {
    const input = document.querySelector(`input[name="${name}"]`);
    return input ? input.value : '';
  }

  function getRenderedName(state) {
    const raw = (state.name || '').trim();

    if (!raw) return '';

    if (state.font === 'stampatello') {
      return raw.toUpperCase();
    }

    return raw.replace(/^(\s*)(\S)/, (match, spaces, firstChar) => spaces + firstChar.toUpperCase());
  }

  function fitName(ctx, text, fontFamily, startSize, maxWidth, maxHeight, wrapBelowPx, fontKey, hardFloor = 28) {
    text = (text || '').replace(/\s+/g, ' ').trim();
    if (!text) return { lines: [], fontSize: startSize };

    const measure = (value, size) => {
      ctx.font = `${size}px ${fontFamily}`;
      return ctx.measureText(value).width;
    };

    const wrapThreshold = Math.max(hardFloor, wrapBelowPx || hardFloor);
    const words = text.split(' ').filter(Boolean);
    const charCountNoSpaces = text.replace(/\s/g, '').length;
    const forceWrapAfterChars = CONFIG.layout.name.forceWrapAfterChars?.[fontKey] ?? 999;

    let singleSize = startSize;
    while (singleSize > hardFloor && measure(text, singleSize) > maxWidth) {
      singleSize -= 2;
    }

    if (words.length < 2) {
      return { lines: [text], fontSize: singleSize };
    }

    const forceWrapByChars = charCountNoSpaces >= forceWrapAfterChars;
    const forceWrapBySize = singleSize < wrapThreshold;

    if (!forceWrapByChars && !forceWrapBySize) {
      return { lines: [text], fontSize: singleSize };
    }

    const divisor = CONFIG.layout.name.twoLineCapDivisor?.[fontKey] || 1.78;
    const twoLineCap = Math.max(hardFloor, Math.floor(maxHeight / divisor));

    let best = null;

    for (let i = 1; i < words.length; i += 1) {
      const line1 = words.slice(0, i).join(' ').trim();
      const line2 = words.slice(i).join(' ').trim();

      if (!line1 || !line2) continue;

      let candidateSize = twoLineCap;

      while (
        candidateSize > hardFloor &&
        (measure(line1, candidateSize) > maxWidth || measure(line2, candidateSize) > maxWidth)
      ) {
        candidateSize -= 2;
      }

      if (candidateSize <= hardFloor) continue;

      const balance = Math.abs(line1.length - line2.length);
      const widestLine = Math.max(measure(line1, candidateSize), measure(line2, candidateSize));

      if (
        !best ||
        candidateSize > best.fontSize ||
        (candidateSize === best.fontSize && balance < best.balance) ||
        (candidateSize === best.fontSize && balance === best.balance && widestLine < best.widestLine)
      ) {
        best = {
          lines: [line1, line2],
          fontSize: candidateSize,
          balance,
          widestLine
        };
      }
    }

    if (best) return { lines: best.lines, fontSize: best.fontSize };

    return { lines: [text], fontSize: singleSize };
  }

  async function ensureFontsLoaded() {
    if (fontsReady) return;

    try {
      if (document.fonts && document.fonts.load) {
        await Promise.all([
          document.fonts.load('124px "Stampatello"'),
          document.fonts.load('102px "Corsivo"')
        ]);
      }
    } catch (error) {
      console.warn('Font preview non caricati al primo tentativo', error);
    }

    fontsReady = true;
  }

  function getState() {
    return {
      name: getInputValue('Nome'),
      backpack: valueMaps.backpack[getCheckedValue('Colore')] || 'natural',
      font: valueMaps.font[getCheckedValue('Stile')] || 'corsivo',
      design: valueMaps.design[getCheckedValue('Disegno')] || 'leone',
      gift: getCheckedValue('Box regalo') || 'No'
    };
  }

 async function render() {
  const myToken = ++renderToken;

    const root = document.getElementById('hbPreviewRoot');
    const canvas = document.getElementById('hbPreviewCanvas');
    const giftBadge = document.getElementById('hbPreviewGift');
    const configData = getConfigData();

    if (!root || !canvas || !configData) return;

    const ctx = canvas.getContext('2d');
    const state = getState();

    const backpackSrc = configData.backpacks[state.backpack];
    const designSrc = configData.designs[state.design];
    const specificCordsSrc =
  (configData.cords && configData.cords[state.backpack]) || null;

const defaultCordsSrc =
  (configData.cords && configData.cords.default) || null;

    try {
      await ensureFontsLoaded();

      const [backpackImage, designImage, specificCordsOverlay, defaultCordsOverlay] = await Promise.all([
  loadImage(backpackSrc),
  loadImage(designSrc),
  loadOptionalImage(specificCordsSrc),
  loadOptionalImage(defaultCordsSrc)
]);

if (myToken !== renderToken) return;

const cordsOverlay = specificCordsOverlay || defaultCordsOverlay;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      if (backpackImage) {
        ctx.drawImage(backpackImage, 0, 0, canvas.width, canvas.height);
      }

      if (designImage) {
        const layout = CONFIG.layout.design;
        const override = CONFIG.overrides[state.design] || {};
        const maxW = override.maxWidth ?? layout.maxWidth;
        const maxH = override.maxHeight ?? layout.maxHeight;

        const scale = Math.min(
          maxW / designImage.naturalWidth,
          maxH / designImage.naturalHeight
        );

        const drawW = designImage.naturalWidth * scale;
        const drawH = designImage.naturalHeight * scale;
        const drawX = layout.centerX - drawW / 2;
        const drawY = layout.centerY - drawH / 2;

        ctx.drawImage(designImage, drawX, drawY, drawW, drawH);
      }

      if (cordsOverlay) {
        ctx.drawImage(cordsOverlay, 0, 0, canvas.width, canvas.height);
      }

      const renderedName = getRenderedName(state);

      if (renderedName) {
        const layout = CONFIG.layout.name;
        const textColor = (CONFIG.textColors[state.design] || {})[state.backpack] || '#483023';

        const fontKey = state.font === 'stampatello' ? 'stampatello' : 'corsivo';
        const fontFamily =
          state.font === 'stampatello'
            ? '"Stampatello", Arial, sans-serif'
            : '"Corsivo", cursive';
        const startSize = layout.fontSizePx[fontKey] || 100;

        const { lines, fontSize } = fitName(
          ctx,
          renderedName,
          fontFamily,
          startSize,
          layout.maxWidth,
          layout.maxHeight,
          layout.wrapBelowPx,
          fontKey,
          28
        );

        ctx.fillStyle = textColor;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = `${fontSize}px ${fontFamily}`;

        if (lines.length === 1) {
          ctx.fillText(lines[0], layout.centerX, layout.centerY);
        } else if (lines.length === 2) {
          const offsetFactor = layout.twoLineOffsetFactor[fontKey] || 0.55;
          const lineOffset = fontSize * offsetFactor;
          ctx.fillText(lines[0], layout.centerX, layout.centerY - lineOffset);
          ctx.fillText(lines[1], layout.centerX, layout.centerY + lineOffset);
        }
      }

      if (giftBadge) {
        giftBadge.hidden = state.gift !== 'Si';
      }
    } catch (error) {
      console.error('Errore preview:', error);
    }
  }

  function isRelevantTarget(target) {
    if (!target || !target.matches) return false;

    return target.matches(
      'input[name="Nome"], input[name="Colore"], input[name="Stile"], input[name="Disegno"], input[name="Box regalo"]'
    );
  }

  function preloadAllPreviewAssets() {
  const configData = getConfigData();
  if (!configData) return;

  const urls = [
    ...Object.values(configData.backpacks || {}),
    ...Object.values(configData.designs || {}),
    ...Object.values(configData.cords || {})
  ].filter(Boolean);

  const run = () => {
    urls.forEach((url) => {
      loadOptionalImage(url).catch(() => {});
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 2000 });
  } else {
    setTimeout(run, 800);
  }
}

function init() {
  const root = document.getElementById('hbPreviewRoot');
  if (!root || root.dataset.previewInitialized === 'true') return;

  root.dataset.previewInitialized = 'true';

  render();
  preloadAllPreviewAssets();

  document.addEventListener('input', (event) => {
    if (isRelevantTarget(event.target)) render();
  }, true);

  document.addEventListener('change', (event) => {
    if (isRelevantTarget(event.target)) render();
  }, true);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();